// ***********************************************************************
//
// HlsVideoTrack
//
// A HTML Video Element Track that uses HLS for adaptive quality streaming
//
// ***********************************************************************

import VideoTrack from './VideoTrack'
import Hls from 'hls.js/dist/hls.light.min'

class HlsVideoTrack extends VideoTrack {
  constructor(trackConfig) {
    super(trackConfig)
    this.hls = new Hls()
    console.log('HlsVideoTrack')
  }

  load = () => {
    return new Promise(resolve => {
      let src = this.config.src.filter(src => src.isHls)[0]
      console.log('HlsVideoTrack', src)

      this.hls.loadSource(src.url)
      this.hls.attachMedia(this.el)
      this.hls.on(Hls.Events.MANIFEST_PARSED, function() {
        resolve()
      })
    })
  }
}

export default HlsVideoTrack
